import { MessageCircle } from "lucide-react";
import { getWhatsAppUrl } from "@/config/contact";

const WHATSAPP_MESSAGE = "Hi! I'd like to enquire about your gifts. 🌸";

export default function WhatsAppButton() {
  const url = getWhatsAppUrl(WHATSAPP_MESSAGE);

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-fab">
      {/* Ping ring */}
      <span className="absolute inset-0 rounded-full bg-green-400 opacity-30 animate-ping-slow" />
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-link"
      >
        <MessageCircle className="w-7 h-7 text-white fill-white" />
      </a>
    </div>
  );
}
